export enum LanguageType {
    ar = 1,
    en = 2,
}
